module.exports = __webpack_public_path__ + "img/underline.8e22b1a2.svg";